import { getBreadCrumbLevels } from '../tempComponents/TempBreadcrumbs';
import { GM_PACKAGE } from '../constants';

const getGMBreadcrumbTemplate = (breadCrumbs, packageName) => {
  if (breadCrumbs?.length === 3) {
    return {
      levelOne: { title: breadCrumbs?.[1]?.label, url: breadCrumbs?.[1]?.url },
      levelTwo: { title: packageName, url: '' },
    };
  }
  return {
    levelOne: { title: breadCrumbs?.[1]?.label, url: breadCrumbs?.[1]?.url },
    levelTwo: { title: breadCrumbs?.[2]?.label, url: breadCrumbs?.[2]?.url },
    levelThree: { title: packageName, url: '' },
  };
};

export const getGMBreadCrumbLevels = ({ metadata, breadCrumbs }) => {
  const { name, brandName } = metadata;
  let packageName = name;
  if (!name?.includes(brandName)) {
    packageName = `${brandName} ${name}`;
  }
  return getGMBreadcrumbTemplate(breadCrumbs, packageName);
};

const getProductsFromPackage = ({ products }) => {
  return Object.values(products?.reduce((acc, item) => {
    const productGroupName = item.info?.productGroup || item.itemId;
    if (!acc[productGroupName]) {
      acc[productGroupName] = item;
    }
    return acc;
  }, {})) || [];
};

// eslint-disable-next-line max-len
export const triggerPackageAnalytics = (packages, storeId, metadata, breadCrumbs, packageId, isCustomerIdentified) => {
  const isGMPackage = metadata?.packageCategory === GM_PACKAGE;
  // the storeId check is to avoid sending two Adobe Analytics beacons resulting in inflated page view counts
  if (packages?.length && packages?.[0]?.products?.length && storeId !== '8119') {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('packages.page-data', {
      packages: isGMPackage ? packages : [{
        ...packages[0],
        products: getProductsFromPackage(packages[0]),
      }],
      breadcrumbs: isGMPackage
        ? getGMBreadCrumbLevels({ metadata, breadCrumbs })
        : getBreadCrumbLevels({ metadata, packageId }),
      packageCategory: metadata?.packageCategory,
      isBrandPricingPolicyCompliant: isCustomerIdentified
    });
  }
};